module.exports = __webpack_public_path__ + "img/kx5200-char-4.5c9a5a7d.png";